function fixTarget() {
  const links = document.querySelectorAll('.wpdt-link-content');

  links.forEach((item) => {
    const elem = item;
    const target = elem.dataset.linkTarget;
    const label = item.text;
    elem.setAttribute('target', target);
    elem.ariaLabel = label;
  });
}

function a11yTable() {
  const tables = document.querySelectorAll('.wpDataTable');

  // prepare string suitable for id
  function prepareId(string) {
    return string.trim().toLowerCase().replaceAll(/&amp; |[,()]/gi, '').replaceAll(/(\s)+/gi, '_');
  }

  tables.forEach((table) => {
    const colsIds = [];
    const rowGroupsIds = [];
    let currentRowGroup = -1;

    // add and collect ids of columns
    table.querySelectorAll('th').forEach((col, key) => {
      const id = prepareId(col.innerText);

      col.setAttribute('id', id);
      colsIds[key] = id;
    });

    // table row iteration
    table.querySelectorAll('tbody tr').forEach((row) => {
      const firstTd = row.querySelector('td:first-child');

      if (row.children.length < colsIds.length) {
        const id = prepareId(firstTd.innerHTML);

        firstTd.id = id;
        rowGroupsIds.push(id);
        currentRowGroup++;
      } else {
        row.querySelectorAll('td').forEach((cell, key) => {
          let headers;

          if (key === 0) {
            headers = `${colsIds[key]} ${rowGroupsIds[currentRowGroup]}`;
            const id = prepareId(cell.innerText);
            cell.setAttribute('id', id);
          } else {
            headers = `${rowGroupsIds[currentRowGroup]} ${firstTd.id} ${colsIds[key]}`;
          }

          cell.setAttribute('headers', headers);
        });
      }
    });
  });
}

window.document.addEventListener('DOMContentLoaded', () => {
  fixTarget();
  a11yTable();
});
